import React, { useEffect, useState } from 'react';
import { BaseButton, Input, useAuth, useT } from '@repo/common';
import HeaderText from '../../Common/HeaderText';
import { updateUserProfile } from '../../../../api/user/user.api';

const JourneyGoal = () => {
  const { user, refreshUser } = useAuth();
  const t = useT();
  const goal = user?.goal;

  const [showGoalTextArea, setShowGoalTextArea] = useState(false);
  const [goalInput, setGoalInput] = useState('');

  useEffect(() => {
    if (goal) {
      setGoalInput(goal);
    }
  }, [goal]);

  const handleSave = async () => {
    try {
      await updateUserProfile({ ...user, goal: goalInput });
      await refreshUser();
      setShowGoalTextArea(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div
      className={`flex flex-col tabletH:max-w-[568px] items-start gap-2 w-full ${
        showGoalTextArea ? '' : 'tabletH:pb-6'
      }`}
    >
      <HeaderText
        label={'Your Journey Goal'}
        showGoalTextArea={showGoalTextArea}
      />
      {showGoalTextArea ? (
        <div className='flex flex-col w-full gap-12'>
          <Input
            as='textarea'
            label=''
            placeholder={t('Tell us your goal for your journey in Korea.', '한국에서의 여정 목표를 알려주세요.')}
            value={goalInput}
            onChange={(e) => setGoalInput(e.target.value)}
            textareaMinHeight='152px'
            maxLength={200}
            className='max-h-[152px]'
          />
          <div className='flex justify-end items-center gap-2'>
            <BaseButton
              type='secondary'
              size='l'
              hideIcon
              bgclass='bg-transform'
              onClick={() => setShowGoalTextArea(false)}
            >
              {t('Cancel', '취소')}
            </BaseButton>
            <BaseButton
              size='l'
              hideIcon
              onClick={handleSave}
              isDisabled={!goalInput.trim()}
            >
              {t('Save Goal', '목표 저장')}
            </BaseButton>
          </div>
        </div>
      ) : goal ? (
        <div className='flex items-start gap-2 whitespace-pre-wrap'>
          {goal}
          <button
            className='text-text-secondary typo-b14 underline'
            onClick={() => {
              setGoalInput(goal);
              setShowGoalTextArea(true);
            }}
          >
            {t('edit', '수정')}
          </button>
        </div>
      ) : (
        <>
          <BaseButton
            type='text_basic'
            size='l'
            bgclass='bg-transform border-none'
            hoverclass='hover:bg-grayscale-gray02 hover:text-grayscale-gray07 active:text-grayscale-gray07'
            onClick={() => setShowGoalTextArea(true)}
          >
            {t('Add your goal', '목표 추가')}
          </BaseButton>
        </>
      )}
    </div>
  );
};

export default JourneyGoal;
